export const PASSWORD_VALIDATION_REGEX = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-+_!@#$%^&*.,?(){}]).*$';

export const US_PHONE_NUMBER_REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

export const US_ZIP_REGEX = /^([0-9]{5})-?([0-9]{4})?$/;
